import * as React from 'react'
import styled from 'styled-components'

import { Container } from '@espoon-voltti/react-components/layout'
import { Title, Button } from '@espoon-voltti/react-components/elements'

import { t } from '../../i18n'
import { getCreateOrgLink } from '../../utils/service-url-providers'
import { Store } from '../../services/use-store'

import { OrgList } from './org-list'
import { CreateAppBtn } from './create-app-btn'

const TopMargin = styled.div`
  margin-top: 60px;
`

const CreateOrgWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;

  .title {
    flex: 1;
  }
`
const CreateOrgBtn = styled(Button)`
  min-width: 250px;
`

export const Home: React.FC = () => {
  const store = Store.use()
  const orgs = store.orgs
  const activePeriods = store.activePeriods()

  return (
    <div data-qa="home">
      <TopMargin />
      <Container dataQa="orgList">
        <CreateOrgWrapper>
          <Title tag={2} dataQa="orgListMainTitle" size={3}>
            {t(['views', 'home', 'orgs', 'title'])}
          </Title>
          <a href={getCreateOrgLink()} tabIndex={-1}>
            <CreateOrgBtn primary={true} dataQa={'createOrgBtn'}>
              {t(['views', 'home', 'orgs', 'createOrgAction'])}
            </CreateOrgBtn>
          </a>
        </CreateOrgWrapper>

        {orgs.length > 0 ? (
          <OrgList orgs={orgs} />
        ) : (
          activePeriods.map((x) => (
            <>
              {x.type === 'YOUTH_PROJECT_GRANT' ? (
                <CreateAppBtn
                  key={x.id}
                  grantPeriodId={x.id}
                  disabled={true}
                  label={t([
                    'views',
                    'home',
                    'org',
                    'applyForGrant',
                    'YOUTH_PROJECT_GRANT'
                  ])}
                  text={t(['views', 'home', 'org', 'applyForGrant', 'date'], {
                    date: x.endDatetime.format('fi')
                  })}
                />
              ) : (
                <CreateAppBtn
                  key={x.id}
                  grantPeriodId={x.id}
                  disabled={true}
                  label={t([
                    'views',
                    'home',
                    'org',
                    'applyForGrant',
                    'YOUTH_GENERAL_GRANT'
                  ])}
                  text={t(['views', 'home', 'org', 'applyForGrant', 'date'], {
                    date: x.endDatetime.format('fi')
                  })}
                />
              )}
            </>
          ))
        )}
      </Container>
    </div>
  )
}
